<template lang="pug">
  div
    div.label.basic600--text.text-uppercase {{ $t('fulfilment_method') }}
    v-layout.my-6.px-2.pt-2(v-if="isFetching")
      v-row.fill-height.ma-0(align='center' justify='center')
        v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
    div.mt-2(v-else v-for="method in shippingMethods")
      y-checkbox(v-model="method.check" :color="$vuetify.theme.themes[$theme].info500" @change="selectParent(method)")
        template(v-slot:label)
          div.p2.my-auto {{ method.label }}
      v-row.ml-6(v-if="method.check" no-gutters)
        v-col(cols="6" v-for="(choice, i) in method.choices" :key="i")
          div.mt-1
            y-checkbox(v-model="choice.check" :color="$vuetify.theme.themes[$theme].info500" @change="selectChild")
              template(v-slot:label)
                div.p2.my-auto {{ choice.label }}
</template>

<script>
export default {
  name: 'ShippingOrder',
  props: ['parentShippingOrder', 'company'],
  data: () => ({
    isFetching: false,
    shippingMethods: null,
  }),
  computed: {
    shippingOrder: {
      get () {
        return this.parentShippingOrder
      },
      set (newValue) {
        this.$emit('update:parentShippingOrder', newValue)
      }
    },
  },
  watch: {
    shippingOrder (val) {
      if (!val) {
        this.shippingMethods.forEach(o => {
          this.$set(o, 'check', false)
        })
      }
    }
  },
  mounted () {
    this.fetchFulfilmentMethods()
  },
  methods: {
    fetchFulfilmentMethods () {
      this.isFetching = true
      this.$axios.get(`/leads/filter_options?company=${this.company.id}&type=fulfilment_methods`)
        .then(resp => {
          let tempdata = resp.data
          tempdata.forEach(o => {
            this.$set(o, 'check', false)
            if (o.choices && o.choices.length > 0) {
              o.choices.map(m => { return { ...m, check: false } })
            }
          })
          // tempdata = tempdata.map(m => { return { ...m, check: false } })
          // tempdata = tempdata.filter(f => f.choices && f.choices.length > 0).map(m => { return { ...m, choices: m.choices.map(a => { return { ...a, check: false } }) } })
          this.shippingMethods = tempdata
          if (this.shippingOrder) {
            if (this.shippingOrder.courier && this.shippingOrder.courier.length > 0) {
              this.shippingMethods.filter(f => f.value === 'courier')[0].check = true
              this.shippingOrder.courier.forEach(o => {
                if (this.shippingMethods.filter(f => f.value === 'courier')[0].choices.filter(r => r.value === o).length > 0) {
                  this.shippingMethods.filter(f => f.value === 'courier')[0].choices.filter(r => r.value === o)[0].check = true
                }
              })
            }
            if (this.shippingOrder.local_delivery && this.shippingOrder.local_delivery.length > 0) {
              this.shippingMethods.filter(f => f.value === 'local_delivery')[0].check = true
              this.shippingOrder.local_delivery.forEach(o => {
                if (this.shippingMethods.filter(f => f.value === 'local_delivery')[0].choices.filter(r => r.value === o).length > 0) {
                  this.shippingMethods.filter(f => f.value === 'local_delivery')[0].choices.filter(r => r.value === o)[0].check = true
                }
              })
            }
            if (this.shippingOrder.store_pickup) {
              this.shippingMethods.filter(f => f.value === 'store_pickup')[0].check = true
            }
            if (this.shippingOrder.manual && this.shippingOrder.manual.length > 0) {
              this.shippingMethods.filter(f => f.value === 'manual')[0].check = true
              this.shippingOrder.manual.forEach(o => {
                if (this.shippingMethods.filter(f => f.value === 'manual')[0].choices.filter(r => r.value === o).length > 0) {
                  this.shippingMethods.filter(f => f.value === 'manual')[0].choices.filter(r => r.value === o)[0].check = true
                }
              })
            }
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    updateShippingOrder () {
      let data = {}
      if (this.shippingMethods) {
        this.shippingMethods.forEach(method => {
          if (method.check) {
            if (method.choices && method.choices.length > 0) {
              this.$set(data, [method.value], method.choices.filter(f => f.check).map(m => m.value))
              if (method.choices.filter(f => f.check).length === 0) {
                this.$set(method, 'check', false)
              }
            } else {
              this.$set(data, [method.value], true)
            }
          }
        })
      }
      this.shippingOrder =  data
    },
    selectParent (method) {
      if (method.check) {
        if (method.choices && method.choices.length > 0) {
          this.$set(method, 'choices', method.choices.map(m => { return { ...m, check: true } }))
        }
      } else {
        if (method.choices && method.choices.length > 0) {
          this.$set(method, 'choices', method.choices.map(m => { return { ...m, check: false } }))
        }
      }
      this.updateShippingOrder()
    },
    selectChild () {
      this.updateShippingOrder()
    }
  }
}
</script>